<div id="app-spinner-shade">
    <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex-center-content full-screen flex-col">
    <div class="mat-typography white-black-stroked text-center" *ngFor="let message of messageParcel.messages">
        {{ message}}
    </div>
</div>
